import React from 'react';
import { User } from 'lucide-react';

export const ReviewDriverHeader = ({ name, avatarUrl, vehicleModel, isCustomerReview }) => {
  const displayName = name || (isCustomerReview ? 'Conductor Bryemma' : 'Pasajero Bryemma');

  return (
    <div className="text-center mb-3">
      <div className="position-relative d-inline-block mb-2">
        {avatarUrl ? (
          <img
            src={avatarUrl}
            alt={displayName}
            className="rounded-circle object-fit-cover shadow-sm"
            style={{ width: '64px', height: '64px', border: '2px solid var(--bry-accent, #0EABB0)' }}
          />
        ) : (
          <div
            className="rounded-circle d-flex align-items-center justify-content-center mx-auto shadow-sm"
            style={{
              width: '64px',
              height: '64px',
              backgroundColor: 'rgba(14, 171, 176, 0.15)',
              border: '2px solid var(--bry-accent, #0EABB0)',
              color: 'var(--bry-accent, #0EABB0)'
            }}
          >
            <User size={30} />
          </div>
        )}
      </div>

      <h5 className="text-white fw-bold mb-1">{displayName}</h5>
      {vehicleModel && (
        <span className="badge rounded-pill px-3 py-1" style={{ backgroundColor: 'rgba(14, 171, 176, 0.15)', color: 'var(--bry-accent, #0EABB0)', border: '1px solid var(--bry-accent, #0EABB0)' }}>
          {vehicleModel}
        </span>
      )}
    </div>
  );
};

export default ReviewDriverHeader;
